import { render } from "./TaoThongBaoTest.vue?vue&type=template&id=d402459c&scoped=true"
import script from "./TaoThongBaoTest.vue?vue&type=script&lang=js"
export * from "./TaoThongBaoTest.vue?vue&type=script&lang=js"

import "./TaoThongBaoTest.vue?vue&type=style&index=0&id=d402459c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d402459c"]])

export default __exports__